export default __webpack_public_path__ + "static/media/MISTRZ_SZYBKOSCI.4aa7dc93.png";